import React, { useState } from "react";
import { Link } from "gatsby";
import {
  FaRegListAlt,
  FaHome,
  FaChartBar,
  FaUsers,
  FaIdBadge,
  FaRegCalendarAlt,
  FaArrowLeft,
  FaFutbol,
  FaChevronDown,
} from "react-icons/fa/";

import { seasons, currentSeasonId } from "../util/seasons";

const MenuItem = ({ path, closeMenu, children }) => (
  <Link
    to={path}
    onClick={closeMenu}
    className="border-0 border-b-2 border-indigo-400 pt-8"
  >
    {children}
  </Link>
);

const MenuName = ({ children, Icon = null }) => (
  <div className="m-1 ml-8 flex text-black dark:text-white">
    {Icon && (
      <div className="h-8 w-8 pt-1">
        <Icon className="fill-indigo-600" />
      </div>
    )}
    {children}
  </div>
);

const SeasonsMenuItem = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-0 border-b-2 border-indigo-400 pt-8">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between"
      >
        <MenuName Icon={FaArrowLeft}>Sezonlar</MenuName>
        <FaChevronDown
          className={`fill-indigo-600 mr-8 w-3 h-3 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <div className="flex flex-col">
          {seasons.map((season) =>
            season.id === currentSeasonId ? (
              <span
                key={season.id}
                className="m-1 ml-16 mb-4 font-semibold text-pink-500"
              >
                {season.label}
              </span>
            ) : (
              <a
                key={season.id}
                href={season.url}
                target="_blank"
                rel="noreferrer"
                className="m-1 ml-16 mb-4 text-black dark:text-white"
              >
                {season.label}
              </a>
            )
          )}
        </div>
      )}
    </div>
  );
};

const MenuBar = (props) => {
  return (
    <div className="lg:hidden h-full w-full mt-8">
      <div className="flex z-10 flex-col w-full bg-white text-white font-bold dark:bg-gray-900 pt-20">
        <MenuItem path="/" {...props}>
          <MenuName Icon={FaHome}>Ana Sayfa</MenuName>
        </MenuItem>
        <MenuItem path="/takim-istatistikleri/" {...props}>
          <MenuName Icon={FaChartBar}>Takım İstatistikleri</MenuName>
        </MenuItem>
        <MenuItem path="/fikstur/" {...props}>
          <MenuName Icon={FaRegCalendarAlt}>Fikstür ve Sonuçlar</MenuName>
        </MenuItem>
        <MenuItem path="/puan-durumu/" {...props}>
          <MenuName Icon={FaRegListAlt}>Puan Durumu</MenuName>
        </MenuItem>
        <MenuItem path="/takimlar/" {...props}>
          <MenuName Icon={FaUsers}>Takımlar</MenuName>
        </MenuItem>
        <MenuItem path="/lig-liderleri/" {...props}>
          <MenuName Icon={FaFutbol}>Lig Liderleri</MenuName>
        </MenuItem>
        <MenuItem path="/hakemler/" {...props}>
          <MenuName Icon={FaIdBadge}>Hakemler</MenuName>
        </MenuItem>
        <SeasonsMenuItem />
      </div>
    </div>
  );
};

export default MenuBar;
